@if (hint) {
  <div class="Label-Text pm-form-hint mt-1">
    @if (hint?.icon) {
      <span class="material-symbols-outlined hint-icon">{{ hint?.icon }}</span>
    }
    @if (hint?.value) {
      <span>
        {{ hint?.value }}
      </span>
    }
  </div>
}
